import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { readTags, Shape as TagShape } from 'next/entities/tags';
import {
  H1,
  Page,
  PageActions,
  PageBody,
  PageHeader,
  PageTitle,
} from 'next/components/ui';
import {
  read as getFlows,
  readFlows,
  Shape as FlowShape,
} from 'next/entities/flows';
import { asRequest } from 'next/entities/requests';
import { Loading } from 'next/components/Listing';
import NewFlowManager from './NewFlowManager';
import FlowsMoreMenu from './FlowsMoreMenu';
import PageList from './PageList';

/**
 * FIXME: There is a brief FOUC on initial load where it shows the empty state
 *        before loading. This appears to be due to how we have the request
 *        selector set up where it returns `loading: undefined`.
 */

const FlowsListingPage = ({ flows = {}, tags = {}, onLoad }) => {
  useEffect(() => {
    onLoad?.();
  }, [onLoad]);

  const { loading: loadingFlows = true } = flows;
  const { loading: loadingTags = true } = tags;
  const loading = loadingFlows || loadingTags;

  return (
    <Page>
      <PageHeader>
        <PageTitle>
          <H1>Flows</H1>
        </PageTitle>

        <PageActions>
          <FlowsMoreMenu />
          <NewFlowManager />
        </PageActions>
      </PageHeader>

      <PageBody>
        {loading && <Loading />}

        {!loading && <PageList tags={tags.data} flows={flows.data} />}

        {/* TODO: Handle error state */}
      </PageBody>
    </Page>
  );
};

FlowsListingPage.propTypes = {
  flows: asRequest(PropTypes.objectOf(FlowShape)),
  tags: asRequest(PropTypes.objectOf(TagShape)),
  onLoad: PropTypes.func,
};

const mapStateToProps = state => ({
  flows: readFlows(state),
  tags: readTags(state),
});

const mapDispatchToProps = {
  onLoad: getFlows,
};

export default connect(mapStateToProps, mapDispatchToProps)(FlowsListingPage);
